(function () {
  'use strict';

  var root = document.currentScript && document.currentScript.closest('product-info');
  if (!root || root.dataset.akStarappsBridge === 'ready') return;
  root.dataset.akStarappsBridge = 'ready';

  var mapNode = root.querySelector('[data-ak-variant-media-map]');
  if (!mapNode) return;

  var mediaByVariant;
  try {
    mediaByVariant = JSON.parse(mapNode.textContent);
  } catch (error) {
    console.error('Adaptive Kidz gallery map could not be read.', error);
    return;
  }

  function selectedVariantId() {
    var input = root.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input && input.value;
  }

  function rawMediaId(value) {
    var match = String(value || '').match(/(\d+)$/);
    return match ? match[1] : '';
  }

  function filterList(list, allowedIds, isThumbnailList) {
    if (!list) return 0;
    var kept = 0;
    list.querySelectorAll('li').forEach(function (item) {
      var reference = isThumbnailList ? item.dataset.target : item.dataset.mediaId;
      if (!allowedIds.has(rawMediaId(reference))) {
        item.remove();
        return;
      }
      item.classList.remove('is-active', 'scroll-trigger--offscreen');
      item.removeAttribute('aria-hidden');
      kept += 1;
    });
    var first = list.querySelector('li');
    if (first) first.classList.add('is-active');
    return kept;
  }

  function replaceStarappsComponent(source, current, allowedIds, isThumbnailList) {
    if (!source || !current) return false;
    var replacement = source.cloneNode(true);
    replacement.classList.add('starapps');
    replacement.style.removeProperty('display');
    replacement.style.opacity = '1';
    var count = filterList(replacement.querySelector('ul'), allowedIds, isThumbnailList);
    if (!count) return false;
    current.replaceWith(replacement);
    return true;
  }

  function wireVisibleGallery(gallery, viewer, thumbnails) {
    if (!gallery || !viewer) return;
    gallery.elements.viewer = viewer;
    gallery.elements.thumbnails = thumbnails || null;

    if (viewer.dataset.akGalleryWired !== 'true') {
      viewer.addEventListener('slideChanged', gallery.onSlideChanged.bind(gallery));
      viewer.dataset.akGalleryWired = 'true';
    }

    if (!thumbnails) return;
    thumbnails.querySelectorAll('[data-target] button').forEach(function (button) {
      if (button.dataset.akGalleryWired === 'true') return;
      var item = button.closest('[data-target]');
      if (!item) return;
      button.addEventListener('click', gallery.setActiveMedia.bind(gallery, item.dataset.target, false));
      button.dataset.akGalleryWired = 'true';
    });
  }

  function syncGallery() {
    var variantId = selectedVariantId();
    var mappedIds = mediaByVariant[variantId];
    if (!mappedIds || !mappedIds.length) return false;

    var gallery = root.querySelector('media-gallery');
    if (!gallery) return false;
    var allowedIds = new Set(mappedIds.map(String));
    var sourceViewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]:not(.starapps)');
    var displayViewer = gallery.querySelector('slider-component[id^="GalleryViewer-"].starapps');
    var sourceThumbs = gallery.querySelector('slider-component[id^="GalleryThumbnails-"]:not(.starapps)');
    var displayThumbs = gallery.querySelector('slider-component[id^="GalleryThumbnails-"].starapps');

    var viewerReady = replaceStarappsComponent(sourceViewer, displayViewer, allowedIds, false);
    var thumbsReady = replaceStarappsComponent(sourceThumbs, displayThumbs, allowedIds, true);
    if (!viewerReady) return false;

    var firstMediaId = mappedIds[0];
    var activeGallery = gallery.querySelector('slider-component[id^="GalleryViewer-"].starapps');
    var activeThumbs = gallery.querySelector('slider-component[id^="GalleryThumbnails-"].starapps');
    if (activeGallery) activeGallery.setAttribute('data-ak-variant-id', variantId);
    if (activeThumbs && thumbsReady) activeThumbs.setAttribute('data-ak-variant-id', variantId);
    wireVisibleGallery(gallery, activeGallery, activeThumbs);
    gallery.setActiveMedia && gallery.setActiveMedia(root.dataset.section + '-' + firstMediaId, true);
    return true;
  }

  function scheduleSync() {
    [80, 350, 900, 1600].forEach(function (delay) {
      window.setTimeout(syncGallery, delay);
    });
  }

  root.addEventListener('change', function (event) {
    if (event.target && event.target.closest('variant-selects')) scheduleSync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }
})();
